import axios from "axios";

const api = axios.create({
  baseURL: "https://ondjilamed.com/api",
  headers: { Accept: "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ondjilamed_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("ondjilamed_client_token");
      localStorage.removeItem("ondjilamed_client");
    }
    return Promise.reject(error);
  },
);

const mediaUrl = "https://ondjilamed.com";
const media = (path) => (path ? `${mediaUrl}${path}` : null);

export { api, media };
